export default "__VITE_ASSET__4a7eb15d__"